import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, MessageSquare, Wrench, Bot, Server, FolderOpen, Settings as SettingsIcon, LogOut } from 'lucide-react';

const Sidebar = ({ setAuth, isMobileOpen, closeMobileMenu }) => {
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/chat', icon: MessageSquare, label: 'AI Chat' },
    { path: '/meta-chat', icon: Wrench, label: 'Мета-Чат' },
    { path: '/agents', icon: Bot, label: 'Агенты' },
    { path: '/ssh', icon: Server, label: 'SSH' },
    { path: '/projects', icon: FolderOpen, label: 'Проекты' },
    { path: '/settings', icon: SettingsIcon, label: 'Настройки' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    setAuth(false);
  };

  const handleLinkClick = () => {
    if (closeMobileMenu) {
      closeMobileMenu();
    }
  };

  return (
    <aside className={`sidebar ${isMobileOpen ? 'sidebar-mobile-open' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <Bot className="sidebar-logo-icon" />
          <div>
            <h2 className="sidebar-title">AI Agents</h2>
            <p className="sidebar-subtitle">Server Manager</p>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={handleLinkClick}
              className={`sidebar-link ${isActive ? 'sidebar-link-active' : ''}`}
            >
              <Icon className="sidebar-icon" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">
            <span>A</span>
          </div>
          <div className="sidebar-user-info">
            <p className="sidebar-user-name">admin</p>
            <p className="sidebar-user-role">Администратор</p>
          </div>
        </div>
        <button onClick={handleLogout} className="sidebar-logout-btn">
          <LogOut size={18} />
          <span>Выход</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
